(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-post"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.press-post__block').forEach(block => {
    const slides = block.querySelectorAll('.press-post__slide');
    const indicators = block.querySelectorAll('.press-post__indicator');
    const prevBtn = block.querySelector('.press-post__arrow--prev');
    const nextBtn = block.querySelector('.press-post__arrow--next');
    const gallery = block.querySelector('.press-post__gallery');
    let currentIndex = 0;
    let touchStartX = 0;
    let touchEndX = 0;

    function goToSlide(index) {
      slides.forEach(slide => slide.classList.remove('active'));
      indicators.forEach(indicator => indicator.classList.remove('active'));
      
      slides[index].classList.add('active');
      indicators[index].classList.add('active');
      currentIndex = index;
    }

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - next slide
          const newIndex = currentIndex < slides.length - 1 ? currentIndex + 1 : 0;
          goToSlide(newIndex);
        } else {
          // Swipe right - previous slide
          const newIndex = currentIndex > 0 ? currentIndex - 1 : slides.length - 1;
          goToSlide(newIndex);
        }
      }
    }

    // Touch events for swipe
    gallery.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    gallery.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    // Click events for arrows
    prevBtn.addEventListener('click', () => {
      const newIndex = currentIndex > 0 ? currentIndex - 1 : slides.length - 1;
      goToSlide(newIndex);
    });

    nextBtn.addEventListener('click', () => {
      const newIndex = currentIndex < slides.length - 1 ? currentIndex + 1 : 0;
      goToSlide(newIndex);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
